module.exports = __webpack_public_path__ + "static/media/lightbulb.f7f0b99e.svg";